import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Antd from 'ant-design-vue'
import '@/styles.scss'
import '@/style/main.scss'
import * as filters from './filters'
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import 'ant-design-vue/dist/antd.css';
import {message} from 'ant-design-vue'

Vue.use(Antd)
Vue.use(ElementUI)

Vue.component('Header', Header);
Vue.component('Footer', Footer);
Vue.prototype.$message = message

// 页面跳转后滚动条位于最上方
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 定义全局的mixin，用于改变标题
Vue.mixin({
  mounted() {
    const title = this.$route.meta && this.$route.meta.title
    if (title) {
      document.title = title // 设置页面标题
    }
  },
  beforeRouteUpdate(to, from, next) {
    const title = to.meta && to.meta.title
    if (title) {
      document.title = title // 当路由改变时更新页面标题
    }
    next()
  }
})


Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
